import Layout from "../../components/Layout";
import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";
import IntegrationCard from "../integration/IntegrationCard";
import brevo from "../../assets/images/brevo.png";
import mailjet from "../../assets/images/mailjet.jpeg";
import mailersend from "../../assets/images/mailersend.png";
import { toast } from "react-toastify";
import { Grid } from "@mui/material";
import { Icon } from "@iconify/react";
import Modal from "../../components/Modal";
import InputGroup from "../../components/FormComponent/InputGroup";
import Button from "../../components/Button";
import useStyles from "../integration/styles";
import { httprequest } from "../../data/api";
import useWindowSize from "../../hooks/useWindow";

const SCHOOL_INTEGRATION = "/api/v1/integrations/school";

const MailingSettings = () => {
  const classes = useStyles();
  const [integrateModal, setIntegrateModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState({ title: "", type: "mail" });
  const [allIntegration, setAllIntegration] = useState([]);
  useWindowSize();

  const [integration, setIntegration] = useState({
    api_key: "",
    secret_key: "",
    email: "",
    name: ""
  });

  const [viewSecretKeys, setViewSecretKeys] = useState({
    api_key: false,
    secret_key: false
  });

  const toggleSecretKey = (key) => {
    setViewSecretKeys((prev) => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleIntegrateModal = (card) => {
    setSelectedCard(card || { title: "", type: "mail" });
    setViewSecretKeys({ api_key: false, secret_key: false });
    setIntegration({
      api_key: "",
      secret_key: "",
      email: "",
      name: ""
    });
    setIntegrateModal(!integrateModal);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setIntegration({
      ...integration, [name]: value
    });
  };

  const getIntegration = () => {
    httprequest.get(SCHOOL_INTEGRATION).then((res) => {
      setAllIntegration(res.data.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const checkIsIntegrated = (title) => {
    return allIntegration.find((integration) => integration?.provider === title);
  };

  const handleSchIntegration = async () => {
    const existingIntegration = allIntegration.find(
      (integration) => integration?.provider === selectedCard?.title
    );
    if (existingIntegration) {
      try {
        const res = await httprequest.delete(`${SCHOOL_INTEGRATION}/${existingIntegration?.id}`);
        if (res.status === 200) {
          toast.success("Integration removed successfully.");
          getIntegration();
          setIntegrateModal(false);
        } else {
          toast.error("Failed to remove integration.");
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Error removing integration.");
      }
    } else {
      const credentials = {
        api_key: integration.api_key,
        secret_key: integration.secret_key,
        email: integration.email,
        name: integration.name
      };

      switch (selectedCard.title) {
      case "BREVO":
        delete credentials.secret_key;
        break;
      case "MAILERSEND":
        delete credentials.secret_key;
        break;
      case "MAILJET":
        // uses api_key + email + name
        break;
      default:
        break;
      }

      const schInfo = {
        credentials,
        provider: selectedCard?.title,
        category: "mail"
      };

      try {
        const res = await httprequest.post(SCHOOL_INTEGRATION, schInfo);
        toast.success(res?.data?.message || "Failed to integrate");
        getIntegration();
        setIntegration({
          api_key: "",
          secret_key: "",
          email: "",
          name: ""
        });
        setIntegrateModal(false);
      } catch (err) {
        toast.error(err?.response?.data?.message || "Error integrating.");
      }
    }
  };

  const mailingCards = [
    { title: "MAILERSEND", logo: mailersend, type: "mail" },
    { title: "BREVO", logo: brevo, type: "mail" },
    { title: "MAILJET", logo: mailjet, type: "mail" }
  ];

  useEffect(() => {
    getIntegration();
  }, []);

  return (
    <Layout children={
      <>
        <PageTitle
          title="Mailing Settings"
          subtitle="Connect mailing providers to send emails from your organisation."
        />
        <div className="left-container white_bg">
          <div>
            <h4>Integration Information</h4>
            <h6 style={{ marginBottom: "8px" }}>See your Integration Information</h6>
          </div>
          <div className={`${classes.maincont} margin-top text-align-left`}>
            <h4>Mailing</h4>
          </div>
          <div className={`${classes.maincont} margin-top text-align-left`}>
            <Grid container spacing={1}>
              {mailingCards.map((card, index) => (
                <Grid item lg={6} md={6} sm={6} xs={12} key={index}>
                  <IntegrationCard
                    title={card.title}
                    logo={card.logo}
                    type={card.type}
                    integrate={() => handleIntegrateModal(card)}
                    isIntegrated={checkIsIntegrated(card.title)}
                    handleIntegrateModal={handleIntegrateModal}
                    handleSchIntegration={() => handleIntegrateModal(card)}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </div>

        <Modal
          title={`${selectedCard.title} Integration`}
          subtitle=""
          isopen={integrateModal}
          closeModal={handleIntegrateModal}
          modalContent={
            <>
              {selectedCard && (
                <>
                  {selectedCard.title === "MAILJET" ? (
                    <Grid container spacing={1} className="input-padding">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <InputGroup
                          label="Name"
                          margin="normal"
                          placeHolder="Enter your name"
                          inputName="name"
                          value={integration.name}
                          onChange={handleInputChange}
                        />
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <InputGroup
                          label="Email"
                          margin="normal"
                          placeHolder="Enter your email"
                          inputName="email"
                          inputType="text"
                          value={integration.email}
                          onChange={handleInputChange}
                        />
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <InputGroup
                          label="API Key"
                          margin="normal"
                          placeHolder="Enter API key"
                          inputName="api_key"
                          value={integration.api_key}
                          onChange={handleInputChange}
                          inputType={viewSecretKeys.api_key ? "text" : "password"}
                        />
                        <div className="password-eye-90" onClick={() => toggleSecretKey("api_key")}>
                          {viewSecretKeys.api_key ? (
                            <Icon icon="fluent:eye-16-regular" />
                          ) : (
                            <Icon icon="iconamoon:eye-off-light" />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container spacing={1} className="input-padding">
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <InputGroup
                          label="API Key"
                          margin="normal"
                          placeHolder="Enter API key"
                          inputName="api_key"
                          value={integration.api_key}
                          onChange={handleInputChange}
                          inputType={viewSecretKeys.api_key ? "text" : "password"}
                        />
                        <div className="password-eye-90" onClick={() => toggleSecretKey("api_key")}>
                          {viewSecretKeys.api_key ? (
                            <Icon icon="fluent:eye-16-regular" />
                          ) : (
                            <Icon icon="iconamoon:eye-off-light" />
                          )}
                        </div>
                      </Grid>
                      {(selectedCard.title === "BREVO" || selectedCard.title === "MAILERSEND") && (
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <InputGroup
                            label="Sender Email"
                            margin="normal"
                            placeHolder="Enter your sender email"
                            inputName="email"
                            inputType="text"
                            value={integration.email}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      )}
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <InputGroup
                          label="Name"
                          margin="normal"
                          placeHolder="Enter display name"
                          inputName="name"
                          value={integration.name}
                          onChange={handleInputChange}
                        />
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
            </>
          }
          modalFooter={
            <div className={`${classes.modalFooterBtn} flex gap-10 margin-top flex-wrap-items-426`}>
              <Button variant="primaryoutline" buttonName="Cancel" buttonSize="full" color="btnfontprimary" onClick={handleIntegrateModal} />
              <Button variant="primary" buttonName={`Integrate ${selectedCard.title}`} buttonSize="full" onClick={handleSchIntegration} color="btndefault" />
            </div>
          }
        />
      </>
    }
    />
  );
};

export default MailingSettings;
